const CURRENCY_SYMBOLS: Record<string, string> = {
  RUB: '₽',
  USD: '$',
  EUR: '€',
};

export const getCurrencySymbol = (currency?: string | null): string =>
  CURRENCY_SYMBOLS[currency || 'RUB'] || currency || '₽';
